<footer>
<div class="room_no">{{room_no}}
    
    </div>

    <div class="clock">
{{ now_date_obj.year }}.{{ now_date_obj.month }}.{{ now_date_obj.day }} （{{ now_date_obj.day_of_week }}） {{ now_date_obj.hhmm }}

</div>
</footer>